import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zeroToPrimary'
})
export class ZeroToPrimaryPipe implements PipeTransform {

  transform(value: any): string {
    if (value === '0') return '0 - Primary';
    return null;
  }

}
